import styled from 'styled-components';

export const DateSelection = styled.div`
justify-content: space-between;
`;

export const DatePickerStyle = styled.div`
margin-top: 8px;
`;

export const DateFilter = styled.div`
padding: 5px;
`;

export const TestStatusLabel = styled.label`
font-size: 11pt;
margin-right: 5px;
white-space: nowrap;
color: var(--primary);
font-weight: 600;
`;

export const FlexContainer = styled.div`
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    gap: 0px;
    margin-bottom: 10px;
    flex-wrap: nowrap;
    min-width: 0px;
    margin-left: 20px;
.Dropdown-control{
border: 1px solid rgb(196 196 196);
height: 25px;
line-height: 15px;
}
.Dropdown-control:focus{
border: 1px solid rgb(196 196 196) !important;
}
`;

export const DateButton = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: end;
    gap: 2px;
    button {
        border-color: transparent;
        background-color: var(--primaryRgb);
        color: #FFFFFF;
        border-radius: 20px;
        width: 84%;
        height: 30px;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
        &:hover {
            background-color: var(--primaryRgb);
        }
    }
`;
